import { render, staticRenderFns } from "./HomePart.vue?vue&type=template&id=edbfcea8&scoped=true&"
import script from "./HomePart.vue?vue&type=script&lang=js&"
export * from "./HomePart.vue?vue&type=script&lang=js&"
import style0 from "./HomePart.vue?vue&type=style&index=0&id=edbfcea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbfcea8",
  null
  
)

export default component.exports